export function modalPopup() {
  window.onload = function () {
    const modals = document.querySelectorAll(".modal");

    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent || modals.length === 0) return;

    modals.forEach((modal) => {
      const modalId = modal.getAttribute("data-modal-id");
      const closeBtn = modal.querySelector("#modal-close");

      const isDismissed = sessionStorage.getItem(`modal_${modalId}`) === "none";

      if (!isDismissed) {
        modal.style.display = "block";
      } else {
        modal.style.display = "none";
      }

      const handleScroll = () => {
        const y = window.scrollY;
        if (y >= 1000 && !isDismissed) {
          modal.classList.add("show-modal");
          modal.classList.remove("hide-modal");
        } else {
          modal.classList.remove("show-modal");
          modal.classList.add("hide-modal");
        }
      };

      window.addEventListener("scroll", handleScroll);

      if (closeBtn) {
        closeBtn.onclick = function () {
          modal.style.display = "none";
          sessionStorage.setItem(`modal_${modalId}`, "none");
        };
      }
    });
  };
}
